import { Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ServicesBox } from "./SevicesBox";
import SlidingBanner from "./Banner";

export const Header = (props) => {
  const [isLearnMore, setIsLearnMore] = useState(false);
  const navigate = useNavigate();

  const banners = [
    {
      id: 1,
      img: "../img/HomeSlide/SLIDE1.jpg",
      alt: "Slide 1",
    },
    {
      id: 2,
      img: "../img/HomeSlide/SLIDE2.jpg",
      alt: "Slide 2",
    },
    {
      id: 3,
      img: "../img/HomeSlide/SLIDE3.jpg",
      alt: "Slide 3",
    },
    {
      id: 3,
      img: "../img/HomeSlide/SLIDE4.jpg",
      alt: "Slide 3",
    },
  ];
  return (
    <header id="header">
      {/* <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8   intro-text" style={{width:"100%"}}>
                <Typography variant="h2" sx={{ fontWeight: "bold" ,color:"#fff", textAlign:"center"}}>
                  Welcome to{" "}
                  <span style={{ color: "color: #009bd6; text-shadow: 0 0 10px #009bd6, 0 0 100px #009bd6, 0 0 130px #009bd6;", boxShadow:""}}>Elite Engineering</span>{" "}
                  Company
                </Typography>
                {/* <h2  style={{}}>
                 
                
                  
                </h2> }
                {isLearnMore && (
                  <p>{props.data ? props.data.paragraph : "Loading"}</p>
                )}
                <button
                  onClick={() => setIsLearnMore(!isLearnMore)}
                  className="btn btn-custom btn-lg page-scroll"
                >
                  {isLearnMore ? "Show Less" : "Learn More"}
                </button>{" "}
              </div>
            </div>
            <ServicesBox/>
          </div>
        </div>
      </div> */}
      <SlidingBanner banners={banners}/>
      <ServicesBox/>
    </header>
  );
};
